
import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatBottomSheet, MatDialog, MatTabChangeEvent } from '@angular/material';
import { Paytype } from '../../../models/paytype.model';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { Member } from '../../../models/member.model';
import { EditMemberSheetComponent } from '../edit-member-sheet/edit-member-sheet';
import { AccountService } from '../../../services/account.service';
import { Permission } from '../../../models/permission.model';
import { MemberAccess } from '../../../models/member-access.model';
import { MemberAccessActionType } from '../../../models/enums';
import { ChangePasswordSheetComponent } from '../change-password-sheet/change-password-sheet';
import { AuthService } from '../../../services/auth.service';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorProductLookup } from '../../../models/vendor-product-lookup.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DependentService } from '../../../services/dependent.service';
import { DependentEventlogDialogComponent } from '../dependent-eventlog-dialog/dependent-eventlog-dialog.component';
import { CaseManagementService } from '../../../services/case-management.service';

@Component({
    selector: 'member-detail-dialog',
    template: require('./member-detail-dialog.component.html'),
    styles: [require('./member-detail-dialog.component.css')]
})
export class MemberDetailDialogComponent {
    @ViewChild('dataTable1') table1: DatatableComponent;
    @ViewChild('dataTable2') table2: DatatableComponent;

    isLoading = true;
    currentMember: Member;
    vendorProductLookupsForCareington: Array<VendorProductLookup> = [];
    currentCase: any = {};
    cmProvider: any = {};
    cmNotes = [];
    caseType = "Pre-authorization";
    eventLogs: Array<any> = [];
    vendorProductId: number;
    writeMembersPermission = Permission.writeMembersPermission;
    manageefulfillmentPermission = Permission.manageefulfillmentPermission;
    ffs = [];
    newFile: any;
    generatingMemberCard: boolean = false;
    sending1stEmail: boolean = false;
    page = {
        pageNumber: 0,
        size: 5
    }
    files: any = [];

    policyNumber_eFulfillment = {};
    apiEventsTab ;
    marketingCampaignsEventsTab;
    documentTemplates = [];
    providers = [];
    isDependentsLoading = true;

    isFirstTabVisible = true;
    isSecondTabVisible = true;

    memberDependents: any = [];

    requireProvider = true;

    sendFileVM = { faxNumber: '19727674531' };

    creatingCM = false;

    isCreateCase: boolean = false;

    caseManagements = [];

    loadingIndicator: boolean = false;

    public cmForm: FormGroup;
    caseManager: any = {};
    providerSepcialtiesList: any[] = []
    
    deliveryPreferenceMap = { null: 'None',0: 'None',1:'Email',2:'Postal'}
    isLoggingInAsMember = false;
    constructor(private bottomSheet: MatBottomSheet, private alertService: AlertService, private apiService: ApiService, public accountService: AccountService,
        private dependentService: DependentService, 
        private authService: AuthService,
        private snotifyService: SnotifyService,
        private fb: FormBuilder, public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private caseManaementService: CaseManagementService,
        private route : Router,
        private spinner: NgxSpinnerService) {

        this.cmForm = this.fb.group({
            caseType: ['', [Validators.required]],
            providerName: ['', [Validators.required, Validators.maxLength(50)]],
            address1: ['', [Validators.required, Validators.maxLength(50)]],
            address2: ['', Validators.maxLength(50)],
            city: ['', [Validators.required, Validators.maxLength(50)]],
            state: ['', [Validators.required, Validators.maxLength(2)]],
            zip: ['', [Validators.required, Validators.maxLength(5)]],
            phone: ['', [Validators.required, Validators.maxLength(10)]],
            fax: ['', [Validators.required, Validators.maxLength(10)]],
            email: ['', Validators.maxLength(50)],
            specialty: ['' ],
            taxId: ['', [Validators.required, Validators.maxLength(9)]],
            panel: ['', Validators.maxLength(50)],
            phf: ['', ],
            contact: ['',  Validators.maxLength(50)],
            contPhone: ['', Validators.maxLength(10)],
            contExt: ['', Validators.maxLength(50) ],
            notes: ['', Validators.maxLength(200)],
            requireProviderCb: [''],
        })

        //if (data) {
        //    this.getSmartVaultClient(data.member.memberId);
        //    this.getUserSSOError(data.member);
        //}
        //else {
        //    alert('s')
        //}
        var memberId = this.activatedRoute.snapshot.params["memberId"];
        this.getUserSSOError(memberId);
        this.getCase(memberId);
        this.getDocTemplates();
        this.searchProviders();
        this.getCasesList(memberId);
        this.getProviderSepcialtiesList();
    }

    getProviderSepcialtiesList() {
        this.caseManaementService.getProviderSepcialtiesList().subscribe(r => {
            console.log(r)
            this.providerSepcialtiesList = r;
        })
    }

    onRefreshCase() {
        this.getCasesList(this.currentMember.memberId);
    }

    goCaseManagement(c) {
        this.route.navigate(['/case-management', c.caseNum])
        console.log(c)
    }

    getCasesList(memberId) {
        this.loadingIndicator = true;
        this.caseManagements = [];
        this.caseManaementService.getCasesList(memberId).subscribe(r => {
            this.caseManagements = r.map(i => { return { ...i, date: new Date(i.dateOpened) } }).sort((a, b) => b.date - a.date);

            this.loadingIndicator = false;

        })
    }

    updateDependentElig(dependent) {
        /*console.log(dependent);*/
        this.dependentService.updateDependentElig(dependent.dependentId).subscribe(r => {
            console.log(r)
        })
    }

    dependentPreRegister(dependentId : string) {
        this.dependentService.dependentPreRegister(dependentId, this.currentMember.memberPolicies[0].productId).subscribe(r => {
            console.log(r)
        })
    }

    onLoadDependent() {
        this.getDependents(this.activatedRoute.snapshot.params["memberId"]);
    }

    getDependents(memberId) {
        this.dependentService.getDependentsAdmin(memberId).subscribe(r => {
            if (r) {
                this.memberDependents = r;
                this.isDependentsLoading = false;
            }
        })
    }

    viewLogEvent(dependentId: string) {
        let dialogRef = null;
        this.dependentService.getDpendentEventLogs(dependentId).subscribe(r => {
            if (r) {
                dialogRef = this.dialog.open(DependentEventlogDialogComponent, {
                    panelClass: 'col-md-10',
                    data: {
                        eventLogs: r
                    }
                })
            }
        })
    }

    renderSSLog(message, type: string = 'body' ) {
        if (type === 'title') {
            let titleIndex = message.indexOf('\n')
            return message(0, titleIndex)
        }
    }
    //refresh event log
    onRefresh() {

        this.eventLogs = [];
        var memberId = this.activatedRoute.snapshot.params["memberId"];
        this.getUserSSOError(memberId);

    }
    getPage(page) {
    }


    getDocTemplates() {
        this.apiService.umapGetDocumentTemplates().subscribe(r => {
            this.documentTemplates = r;
        })
    }

    searchProviders() {
        this.apiService.umapSearchProviders().subscribe(r => {
            this.providers = r;
        })
    }

    sendDoc() {
        this.alertService.showMessage("", "Sending Doc", MessageSeverity.info);
        this.apiService.umapSendFile(this.currentMember.memberId, this.sendFileVM).subscribe(r => {
            this.alertService.showMessage("", "Send Doc successfully!", MessageSeverity.success);
            this.fetchFiles();
        })
    }

    getUserSSOError(memberId, isRefresh = false) {
       // this.alertService.startLoadingMessage("Getting sso logger and vendorProductId");
        this.apiService.getMoreDetailMember(memberId).subscribe(r => {
            this.eventLogs = r.ssoLogger;
            this.currentMember = r.member;
            this.vendorProductId = r.vendorProductId;
            this.vendorProductLookupsForCareington = r.vendorProductLookupsForCareington;
            this.alertService.stopLoadingMessage();

            this.isLoading = false;
            //console.log(this.eventLogs)
            //console.log(this.currentMember.memberPolicies)
            _.each(this.currentMember.memberPolicies, p => {
                this.policyNumber_eFulfillment[p.policyNumber] = {};
                const vendorProduct = _.find(this.vendorProductLookupsForCareington, { productId: p.productId });
                p.hasCareingtonProduct = !!vendorProduct;
                p.vendorProductId = !!vendorProduct ? vendorProduct.vendorProductId : null;

            })
            _.each(_.uniq(_.map(this.currentMember.memberPolicies, 'productId')), productId => {
                this.apiService.getWhitelabelByProductId(productId).subscribe(w => {
                    if (w && w.siteUrl)
                        _.each(_.filter(this.currentMember.memberPolicies, { productId: productId }), p => p.planSiteUrl = "https://" + w.siteUrl);
                }, () => { /* no plan site for this product - plan name stays plain text */ });
            })
            console.log(this.currentMember.memberPolicies)
        });
    }

    ok() {
        
    }

    loginAsMember() {
        this.isLoggingInAsMember = true;
        this.apiService.getWhitelabelByProductId(this.currentMember.memberPolicies[0].productId).subscribe(r => {
            window.open("https://" + r.siteUrl + '/login-with-token?memberId=' + this.currentMember.memberId + '&code=' + this.authService.idToken + '&productId=' + this.currentMember.memberPolicies[0].productId, '_blank');
            this.isLoggingInAsMember = false;
        })
       
    }

    loginAsDependent(dependent) {
        this.apiService.getWhitelabelByProductId(this.currentMember.memberPolicies[0].productId).subscribe(r => {
            window.open("https://" + r.siteUrl + '/login-with-token?memberId=' + dependent.dependentId + '&code=' + this.authService.idToken + '&productId=' + this.currentMember.memberPolicies[0].productId, '_blank');
        })

    }

    openEditMember() {
        this.bottomSheet.open(EditMemberSheetComponent, {
            data: {
                member: this.currentMember
            },
        });
    }

    resetMemberLogin() {
        this.alertService.showDialog("Are you sure you want to reset this member's login?", DialogType.confirm,
            (r) => {
                //console.log(r);
                this.apiService.resetMemberLogin(this.currentMember.memberId).subscribe(res => {
                    if (res) {
                        this.alertService.showMessage("", "Reset member's login successfully!", MessageSeverity.success);

                        var memberAccess = new MemberAccess();
                        memberAccess.startTime = new Date();
                        memberAccess.endTime = new Date();
                        memberAccess.memberAccessActionType = MemberAccessActionType.ResetLogin;
                        memberAccess.note = "Reset Login";
                        memberAccess.memberId = this.currentMember.memberId;
                        this.apiService.createMemberAccess(memberAccess).subscribe(r => {
                        });
                    }

                })
            });        
    }

    resetPassword() {
        this.alertService.showDialog("Are you sure you want to change this member's password?", DialogType.confirm,
            (r) => {
                this.bottomSheet.open(ChangePasswordSheetComponent, {
                    data: {
                        member: this.currentMember
                    },
                });
            });
    }

    resetPassword4Dependent(d) {
        this.alertService.showDialog("Are you sure you want to change this dependent's password?", DialogType.confirm,
            (r) => {

           
                    this.bottomSheet.open(ChangePasswordSheetComponent, {
                        data: {
                            dependent: d
                        },
                    });
             
            });
    }

    tryPreRegisterTelemedSSO() {
        this.isLoading = true;
        this.apiService.addAssociates(this.currentMember.memberId, this.currentMember.memberPolicies[0].productId).subscribe(r =>
        {
            this.isLoading = false;
            alert('Success! Open Console log for more details')
            console.log(r)
        }, err =>
            {
                this.isLoading = false;
                alert('Error! Open Console log for more details')
                console.log(err.error.message)
        })
    }

    getCase(memberId) {
        this.isLoading = true;
        this.apiService.umapGetCaseDetailByMemberId(memberId).subscribe(r => {
            this.isLoading = false;
            console.log(r)
            this.currentCase = r || {};
            if (this.currentCase.caseNum) {
                this.fetchFiles();
            }
            
        });
    }

    private fetchFiles() {
        //this.apiService.getFoldersAndFiles(this.currentSmartVaultClient.id).subscribe(ffsres => {
        //    this.ffs = ffsres;
        //});
        //this.apiService.umapGetCMNotes(this.currentCase.caseNum).subscribe(rCMNotes => {
        //    this.cmNotes = rCMNotes;
        //});
    }


    createCaseManagement() {
        this.creatingCM = true;
        var currentUser = this.accountService.currentUser;
        this.caseManager = {
            externalId: currentUser.id,
            source: '',
            fullName: currentUser.fullName,
            email: currentUser.email,
            extension: ''

        }
        var ccmModel = { member: this.currentMember, cmProvider: this.cmProvider, caseManager : this.caseManager}
        console.log(ccmModel)

        this.apiService.createCaseManagement(this.caseType, ccmModel).subscribe(r => {
            
            this.currentCase = r;
            if (this.currentCase.caseNum) {
                this.fetchFiles();
            }
            //send email
            this.apiService.umapSendFile(this.currentMember.memberId, {
                documentTemplateId: (this.caseType.indexOf('Post') > -1? 2 : 1),
                caseNum: this.currentCase.caseNum
            }).subscribe(res => {
                this.creatingCM = false;
                this.isCreateCase = false;
                this.getCasesList(this.currentMember.memberId);
                this.snotifyService.success("Create new CM successfully!")
                this.apiService.umapGetCMNotes(this.currentCase.caseNum).subscribe(rCMNotes => {
                    this.cmNotes = rCMNotes;
                });
            })

        }, err => {
                this.creatingCM = false;
                this.snotifyService.error("An error has occured.");
                console.log(err)
        });
    }

    getFiles(event) {
        this.newFile = event.target.files[0];

    } 

    uploadFile(event) {
        for (let index = 0; index < event.length; index++) {
            const element = event[index];
            this.files.push(element)
        }
    }

    upload() {
        this.spinner.show();
        _.each(this.files, f => {

            this.apiService.uploadFilesSmartVault(this.currentCase.caseNum, f).subscribe(r =>
            {
                this.deleteAttachmentByName(f.name);
                if (this.files.length == 0) {
                    this.spinner.hide();
                    this.fetchFiles();
                }
            });


        });
    }

    deleteAttachment(index) {
        this.files.splice(index, 1)
    }

    deleteAttachmentByName(fileName) {
        //this.files.splice(index, 1)
        _.remove(this.files, {
            name: fileName
        });
    }

    geteFulfillment(memberId, policyNumber) {
        this.apiService.geteFulfillment(memberId, policyNumber).subscribe(r => {
            this.policyNumber_eFulfillment[policyNumber] = r;

            if(r.emailEvents){
                this.apiEventsTab = r.emailEvents.filter(e=> {
                    return e.singlesendName == null || e.singlesendName == "";
                })
    
                this.marketingCampaignsEventsTab = r.emailEvents.filter(e=> {
                    return e.singlesendName != null;
                }).map(e => {
                    e.rawJson = JSON.parse(e.rawJson)
                    return e;
                })

                console.log(this.marketingCampaignsEventsTab)
            }

           // this.policyNumber_eFulfillment[policyNumber].emailEvents = _.orderBy(this.policyNumber_eFulfillment[policyNumber].emailEvents, 'eventDate')
        })
    }

    onTabChange(event: MatTabChangeEvent) {
        if (event.index === 0) {
          this.isFirstTabVisible = true;
          this.isSecondTabVisible = false;
        } else if (event.index === 1) {
          this.isFirstTabVisible = false;
          this.isSecondTabVisible = true;
        }
      }

    sendeFulfillment(memberId, policyNumber) {
        this.sending1stEmail = true;
        this.apiService.sendeFulfillment(memberId, policyNumber).subscribe(r => {
            this.geteFulfillment(memberId, policyNumber);
            this.sending1stEmail = false;
        }, err =>
            {
                this.alertService.showMessage(JSON.stringify(err), "", MessageSeverity.error);
                this.sending1stEmail = false;
        })
    }

    resendEmail(memberId, policyNumber) {
        this.apiService.sendeFulfillment(memberId, policyNumber, false).subscribe(r => {
            this.alertService.showMessage("", "Resend Email Successfully!", MessageSeverity.success);
        }, err => {

        })
    }

    generatePdf(memberId, policyNumber) {
        this.generatingMemberCard = true;
        this.apiService.generatePdfeFulfillment(memberId, policyNumber).subscribe(r => {
            this.generatingMemberCard = false;
            this.geteFulfillment(memberId, policyNumber);
        }, err => {

        })
    }

    getEmailEvent(emailEvents, status) {
        return _.find(emailEvents, { eventName: status.toLowerCase()})
    }



    //Careington Eli
    updateCareington(p) {
        const data = {
            vendorId: "3000",
            memberId: this.currentMember.memberId,
            policyNumber: p.policyNumber,
            productId: p.productId
        }
        this.apiService.updateCareington(data).subscribe(r => {
            this.snotifyService.success(r.message)
        }, err => {
            this.snotifyService.error(err.error.Message)
        })
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/members/member-detail-dialog/member-detail-dialog.component.ts